import { Form, InputNumber } from 'antd'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useUser } from '../../../context/userContext'
import { currencyHelper } from '../../../shared/utils/currencies'
import { SaudiRiyalIcon } from '../../../shared/utils/icons'

const AmountPriceField = props => {
  const { t } = useTranslation()
  const { user } = useUser()

  const { formatter, parser } = currencyHelper()

  const {
    name = 'amount',
    rules = [
      { required: true, message: t('settings.inventory.amountRequired') },
      { type: 'number', message: t('settings.inventory.amountInvalid') }
    ],
    label = t('settings.inventory.amountTitle'),
    step = 10,
    max = 999999999999,
    maxLength = 20,
    precision = 2,
    style = { width: '100%' },
    autoFocus = false,
    min = 0,
    onChange,
    help,
    disabled,
    passedRef,
    extra,
    hideLabel,
    noStyle,
    hideCurrency,
    formName,
    isPercent,
    ...rest
  } = props

  return (
    <Form.Item name={name} noStyle={noStyle} rules={rules} label={hideLabel ? null : label} help={help} extra={extra}>
      <InputNumber
        inputMode="decimal"
        addonAfter={
          hideCurrency ? null : isPercent ? (
            '%'
          ) : user?.company.currency === 'SAR' ? (
            <SaudiRiyalIcon />
          ) : (
            user?.company.currency || '$'
          )
        }
        className="amount-price-field"
        formatter={formatter}
        parser={parser}
        min={min}
        max={max}
        maxLength={maxLength}
        disabled={disabled}
        step={step}
        precision={precision}
        style={style}
        autoFocus={autoFocus}
        {...rest}
        onChange={onChange}
        ref={passedRef}
        data-testid={`${formName || 'priceField'}-${name}`}
      />
    </Form.Item>
  )
}

AmountPriceField.propTypes = {
  name: PropTypes.any,
  passedRef: PropTypes.any,
  rules: PropTypes.array,
  label: PropTypes.any,
  extra: PropTypes.any,
  help: PropTypes.any,
  max: PropTypes.number,
  min: PropTypes.number,
  maxLength: PropTypes.number,
  precision: PropTypes.number,
  step: PropTypes.number,
  hideCurrency: PropTypes.bool,
  style: PropTypes.object,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  onChange: PropTypes.func
}

export default AmountPriceField
